import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const SingleSelectBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M14 2H2C1.73486 2.00026 1.48066 2.10571 1.29319 2.29319C1.10571 2.48066 1.00026 2.73486 1 3V13C1.00026 13.2651 1.10571 13.5193 1.29319 13.7068C1.48066 13.8943 1.73486 13.9997 2 14H14C14.2651 13.9997 14.5193 13.8943 14.7068 13.7068C14.8943 13.5193 14.9997 13.2651 15 13V3C14.9997 2.73486 14.8943 2.48066 14.7068 2.29319C14.5193 2.10571 14.2651 2.00026 14 2ZM2 3H8V13H2V3Z"
      fill="currentColor"
    />
  </IconContainer>
);
